/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';
import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/account-settings';

const POLICY_LINK = `${config.url.base}about/privacy`;
const TERMS_LINK = `${config.url.base}about/terms`;

const NotificationPreferencesTOS: React.FC = () => {
  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText">
      <FormattedHTMLMessage
        message={_t(
          `Coursera is committed to advancing the science of learning and teaching. Learners are important
                participants in that pursuit. The information we gather from your use of our services makes it
                possible for instructors, researchers, designers, engineers, and others to continuously improve their
                work and, in that process, advance learning and teaching. By using our services, you are also
                participating in research. Read <a href="{termsLink}" style="text-decoration:underline !important;" target="_blank">Terms of Use</a>
                and <a href="{policyLink}" style="text-decoration:underline !important;" target="_blank">Privacy Policy</a>.`
        )}
        termsLink={TERMS_LINK}
        policyLink={POLICY_LINK}
      />
    </Typography2>
  );
};

export default NotificationPreferencesTOS;
